import { type FC, useMemo, useState } from 'react';

import { type GeoMap } from '@editor2/types/pageElements';
import { getDataByMapType } from '@editor2/services/geoMapService';
import { DEFAULT_ROW_DISPLAY_COUNT } from '@editor2/components/Pagination/constants';

import DataTable from './DataTable';
import Pagination from '@editor2/components/Pagination/Paginations';

interface Props {
	courseId: number;
	element: GeoMap;
}

const DataTableWithPagination: FC<Props> = (props) => {
	const { element, courseId } = props;

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(DEFAULT_ROW_DISPLAY_COUNT);

	const currentTableData = useMemo(() => {
		const firstPageIndex = (currentPage - 1) * pageSize;
		const lastPageIndex = firstPageIndex + pageSize;

		const data = getDataByMapType(element.geomap_type)?.slice(firstPageIndex, lastPageIndex);
		return data || [];
	}, [currentPage, pageSize, element.geomap_type]);

	return (
		<>
			<DataTable
				element={element}
				currentPageData={currentTableData}
				courseId={courseId}
				currentPage={currentPage}
				limit={pageSize}
			/>

			<Pagination
				currentPage={currentPage}
				pageSize={pageSize}
				setPageSize={setPageSize}
				totalCount={Object.keys(element.data).length}
				onPageChange={(page) => setCurrentPage(page)}
			/>
		</>
	);
};

export default DataTableWithPagination;
